import CoreAPI from '../Core/CoreAPI';
import { getSessionItem } from '@services/api/src/Domains/Enviroments/EnvironmentsService';

class NotificationsAPI {
  constructor() {
    this.setApi(new CoreAPI(getSessionItem('API_DASHBOARD')));
  }

  setApi(api) {
    this.api = api;
  }

  getAPI() {
    if (!this.api.baseURL) this.setApi(new CoreAPI(getSessionItem('API_DASHBOARD')));

    return this.api;
  }

  async getVersion() {
    const result = await this.getAPI().getInstance().get(`/version`);
    return result;
  }
}

const api = new NotificationsAPI();
export default api;
